import "../src/assets/style.scss"
import "../src/assets/js/tile.js"
import "../src/assets/js/faq.js"
import "../src/assets/js/menu.js"
import "../src/assets/js/sidebar.js"
import "../src/assets/js/load-posts.js"